<template>
    <button @click="reset()" type="button" class="btn text-uppercase btn-sm btn-danger btn-block">
        <li class="fa fa-tachometer"></li> Desabilitar Hodômetro
    </button>
</template>
<script>
import {Comandos, Concox} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        name: 'DesabilitarHodmetro',
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.habilitarHodometro(this.id_rastreador, false);
                Bus.$emit('comandos');
            }
        }
    }
</script>
